import React from 'react';

import {
  AssetsIcon,
  BlocksIcon,
  CodeEditorIcon,
  DomainsIcon,
  FooterIcon,
  GeneralIcon,
  HeaderIcon,
  LayoutsIcon,
  NavigationIcon,
  PageElementsIcon,
  PageSectionsIcon,
  PagesIcon,
  SectionsIcon,
  SettingsIcon,
  SnippetsIcon,
  TemplatesIcon,
  VisualEditorIcon,
  EmailsIcon,
  LocaleIcon,
  ThemeIcon,
  CurlyBracketIcon,
} from "./menuIcons";

export const DOCS_MENU_VALUE = {
  general: '/',
  themes: '/themes',
  visualEditor: '/visual-editor',
  visualHeader: '/visual-editor-header',
  visualPages: '/visual-editor-pages',
  visualSections: '/visual-editor-sections',
  visualFooter: '/visual-editor-footer',
  visualSettings: '/visual-editor-settings',
  codeEditor: '/code-editor',
  codeEditorGlobalObject: '/code-editor-global-object',
  codeLayouts: '/code-editor-layouts',
  codeTemplates: '/code-editor-templates',
  codeSections: '/code-editor-sections',
  codeBlocks: '/code-editor-blocks',
  codeAssets: '/code-editor-assets',
  codeSnippets: '/code-editor-snippets',
  codeLocales: '/code-editor-locale',
  codeSettings: '/code-editor-settings',
  pages: '/pages',
  navigation: '/navigation',
  domains: '/domains',
  emails: '/emails',
}

export const DOCS_MENU_ITEMS = [
  { label: 'General',
    value: DOCS_MENU_VALUE.general,
    type: 'main',
    icon: <GeneralIcon />
  },
  { label: 'Theme',
    value: DOCS_MENU_VALUE.themes,
    type: 'main',
    icon: <ThemeIcon />
  },
  {
    label: 'Visual Editor',
    value: DOCS_MENU_VALUE.visualEditor,
    type: 'sub',
    icon: <VisualEditorIcon />
  },
  {
    label: 'Header',
    value: DOCS_MENU_VALUE.visualHeader,
    type: 'subsub',
    icon: <HeaderIcon />
  },
  {
    label: 'Footer',
    value: DOCS_MENU_VALUE.visualFooter,
    type: 'subsub',
    icon: <FooterIcon />
  },
  {
    label: 'Page Sections',
    value: DOCS_MENU_VALUE.visualSections,
    type: 'subsub',
    icon: <PageSectionsIcon />
  },
  {
    label: 'Page Elements',
    value: DOCS_MENU_VALUE.visualPages,
    type: 'subsub',
    icon: <PageElementsIcon />
  },
  {
    label: 'Theme settings',
    value: DOCS_MENU_VALUE.visualSettings,
    type: 'subsub',
    icon: <SettingsIcon />
  },

  {
    label: 'Code Editor',
    value: DOCS_MENU_VALUE.codeEditor,
    type: 'sub',
    icon: <CodeEditorIcon />
  },
  {
    label: 'Global Object',
    value: DOCS_MENU_VALUE.codeEditorGlobalObject,
    type: 'subsub',
    icon: <CurlyBracketIcon />
  },
  {
    label: 'Layouts',
    value: DOCS_MENU_VALUE.codeLayouts,
    type: 'subsub',
    icon: <LayoutsIcon />
  },
  {
    label: 'Templates',
    value: DOCS_MENU_VALUE.codeTemplates,
    type: 'subsub',
    icon: <TemplatesIcon />
  },
  {
    label: 'Sections',
    value: DOCS_MENU_VALUE.codeSections,
    type: 'subsub',
    icon: <SectionsIcon />
  },
  {
    label: 'Blocks',
    value: DOCS_MENU_VALUE.codeBlocks,
    type: 'subsub',
    icon: <BlocksIcon />
  },
  {
    label: 'Assets',
    value: DOCS_MENU_VALUE.codeAssets,
    type: 'subsub',
    icon: <AssetsIcon />
  },
  {
    label: 'Snippets',
    value: DOCS_MENU_VALUE.codeSnippets,
    type: 'subsub',
    icon: <SnippetsIcon />
  },
  {
    label: 'Locales',
    value: DOCS_MENU_VALUE.codeLocales,
    type: 'subsub',
    icon: <LocaleIcon />
  },
  {
    label: 'Theme Settings',
    value: DOCS_MENU_VALUE.codeSettings,
    type: 'subsub',
    icon: <SettingsIcon />
  },
  { label: 'Pages',
    value: DOCS_MENU_VALUE.pages,
    type: 'main',
    icon: <PagesIcon />
  },
  {
    label: 'Navigation',
    value: DOCS_MENU_VALUE.navigation,
    type: 'main',
    icon: <NavigationIcon />
  },
  { label: 'Domains',
    value: DOCS_MENU_VALUE.domains,
    type: 'main',
    icon: <DomainsIcon />
  },
  {
    label: 'Emails',
    value: DOCS_MENU_VALUE.emails,
    type: 'main',
    icon: <EmailsIcon />
  }
];